import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { api } from '../../services/api';
import {
  mappingDataSuccess,
  mappingFailure,
} from '../../store/ducks/mapping/actions';

export default function useGetMappingData() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  async function execute(distributorId: string) {
    try {
      setLoading(true);
      const response = await api.get(`v1/backoffice/mapping/${distributorId}`);

      if (response.status === 200) {
        dispatch(mappingDataSuccess({ ...response.data }));
      }
    } catch (error) {
      dispatch(mappingFailure());
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
